import { type TokenGroup } from "../../types";

export const amber = {
  name: "amber",
  variables: {
    "1": { type: "color", value: { dark: "#1f1300", light: "#fefdfb" } },
    "2": { type: "color", value: { dark: "#271700", light: "#fff9ed" } },
    "3": { type: "color", value: { dark: "#341c00", light: "#fff4d5" } },
    "4": { type: "color", value: { dark: "#3f2200", light: "#ffecbc" } },
    "5": { type: "color", value: { dark: "#4a2900", light: "#ffe3a2" } },
    "6": { type: "color", value: { dark: "#573300", light: "#ffd386" } },
    "7": { type: "color", value: { dark: "#693f05", light: "#f3ba63" } },
    "8": { type: "color", value: { dark: "#824e00", light: "#ee9d2b" } },
    "9": { type: "color", value: { dark: "#ffb224", light: "#ffb224" } },
    "10": { type: "color", value: { dark: "#ffcb47", light: "#ffa01c" } },
    "11": { type: "color", value: { dark: "#f1a10d", light: "#ad5700" } },
    "12": { type: "color", value: { dark: "#fef3dd", light: "#4e2009" } },
  },
} as const satisfies TokenGroup<"amber">;
